import { render, staticRenderFns } from "./notifications-item.vue?vue&type=template&id=71b67d8d&scoped=true"
import script from "./notifications-item.vue?vue&type=script&lang=js"
export * from "./notifications-item.vue?vue&type=script&lang=js"
import style0 from "./notifications-item.vue?vue&type=style&index=0&id=71b67d8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b67d8d",
  null
  
)

export default component.exports